import { render, staticRenderFns } from "./ReportingPage.vue?vue&type=template&id=02130946&scoped=true&lang=pug&"
import script from "./ReportingPage.vue?vue&type=script&lang=ts&"
export * from "./ReportingPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReportingPage.vue?vue&type=style&index=0&id=02130946&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02130946",
  null
  
)

export default component.exports